import Component from '../core/Component'
import withMedia from '../core/withMedia'

const defaults = {
    media: 'smallWideUp',
}

class Form extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            formFields: [],
            formAttachment: null,
            formAttachmentFile: null
        }
    }

    prepare() {
        this.ref.formFields.forEach(field => {
            field.addEventListener('mouseenter', this.handleEnter)
            field.addEventListener('mouseleave', this.handleLeave)
            field.addEventListener('blur', this.handleBlur)
            field.addEventListener('focus', this.handleEnter)
            field.addEventListener('change', this.handleChange)
        })

        this.ref.formAttachment?.addEventListener('change', this.handleAttachment)
    }

    destroy() {
        this.ref.formFields.forEach(field => {
            field.removeEventListener('mouseenter', this.handleEnter)
            field.removeEventListener('mouseleave', this.handleLeave)
            field.removeEventListener('blur', this.handleBlur)
            field.removeEventListener('focus', this.handleEnter)
            field.removeEventListener('change', this.handleChange)
        })
        this.ref.formAttachment?.removeEventListener('change', this.handleAttachment)
    }

    handleEnter = (event) => {
        event.currentTarget.parentNode.classList.add('is-hovered')
    }

    handleLeave = (event) => {
        if(event.target.value) {
            return
        } else {
            event.target.blur()
            event.currentTarget.parentNode.classList.remove('is-hovered')
        }
    }

    handleBlur = (event) => {

        if(event.target.value) {
            return
        } else {
            event.target.blur()
            event.currentTarget.parentNode.classList.remove('is-hovered')
        }
    }

    handleAttachment = (event) => {
        this.ref.formAttachmentFile.textContent = event.target.files[0].name
        setTimeout(() => {
            this.ref.formAttachmentFile.classList.add('is-selected')
        }, 400)
    }
}

export default withMedia(Form)